import {udSentry} from '@udemy/sentry';
import {udApi} from '@udemy/ud-api';

/**
 * Checks if all courses are included in the user's subscription plan
 * @param courseIds - Array of course IDs to check subscription for
 * @returns Promise<boolean> - Returns true only if all courses are included in the user's subscription plan
 */
export const coursesInSubscriptionPlan = async (
    courseIds: string[] | number[],
): Promise<boolean> => {
    try {
        const promises = courseIds.map((courseId) =>
            udApi.get(`/courses/${courseId}/`, {
                params: {
                    'fields[course]': 'is_in_user_subscription',
                },
            }),
        );

        const responses = await Promise.all(promises);

        const areAllCoursesIncludedInSubscriptionPlan = responses.every(
            (response) => response.data.is_in_user_subscription === true,
        );
        return areAllCoursesIncludedInSubscriptionPlan;
    } catch (error) {
        udSentry.captureException(error);
        return false;
    }
};
